import React from 'react'
import {Route,BrowserRouter} from 'react-router-dom'

import Home from './Panels/Home'
import Games from './Panels/Games'
import Learn from './Panels/Learn'
import Joinme from './Panels/Joinme'
import About from './Panels/About'
const Bodycomponent=()=>{
    return(
  <BrowserRouter>
  <Route path="/" exact={true} component={Home}></Route>
         <Route path="/home" exact={true} component={Home}></Route>
         <Route path="/about" exact={true} component={About}></Route>
         <Route path="/games" exact={true} component={Games}></Route>
         <Route path="/learn" exact={true} component={Learn}></Route>
         <Route path="/joinme" exact={true} component={Joinme}></Route>
         </BrowserRouter>
    )
}
export default Bodycomponent